import { GraphQLClient } from "graphql-request"

const client = new GraphQLClient("https://graphql.datocms.com/", {
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_DATOCMS_TOKEN}`,
    "Content-Type": "application/json"
  }
})

export default client
